module.exports = __webpack_public_path__ + "static/media/public.9601b13b.svg";